var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Pagination from "../../common/components/Pagination";
import { Loading } from 'element-ui';
import { mapGetters } from "vuex";
import PurBackService from "../../api/PurBackService";
import CommonService from "../../api/CommonService";
import GlobalVue from "../../globalVue";
import OtherDetail from "./OtherDetail.vue";
import { toDetail } from "../../helper/util";
import { EBillType } from "../../enum/EBillType";
import { UrlHelper } from "../../helper/UrlWrapper";
import { billDefaultDate } from "../../helper/defaultDate";
import _ from 'lodash';
import BillSubTable from "./BillSubTable.vue";
import { EPurInStatus } from "../../enum/EStatus";
import AreaShop from "@/components/AreaShop";
import Add from './Add.vue';
import ImportData from '../../components/dataActions/ImportData.vue';
import ArtMsglist from '../../components/alert/ArtMsglist.vue';
import ImageView from "../purchasein/components/ImageViewer.vue";
import ConfirmBack from "./component/ConfirmBack.vue";
import SignView from "../purchasein/components/SignView.vue";
import OrderSign from "../../components/common/OrderSign.vue";
import { handleException } from '../../common/ErrorCodeHandle.ts';
function getDefaultFormData() {
    return {
        status: [
            parseInt(EPurInStatus.Bconfirm),
            parseInt(EPurInStatus.Confirmed)
        ],
        client: "",
        searchType: "1",
        text: "",
        account: "-1",
        s_time: billDefaultDate().Start,
        e_time: billDefaultDate().End,
        dateType: "1",
        from_system: ''
    };
}
var PurBackList = (function (_super) {
    __extends(PurBackList, _super);
    function PurBackList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = getDefaultFormData();
        _this.statusList = [];
        _this.clientList = [];
        _this.tableData = [];
        _this.selectedData = [];
        _this.imageOpen = false;
        _this.imageArr = [];
        _this.tableHeight = 0;
        _this.total = 0;
        _this.summary_order_money = 0;
        _this.accounts = [{ name: "全部", id: "-1" }, { name: "已对账", id: "1" }, { name: "未对账", id: "0" }];
        _this.eBillType = EBillType;
        _this.dialogVisible = false;
        _this.exportType = "1";
        _this.isMoreSearch = false;
        _this.dateTypeList = [{ name: "制单日期", id: "1" }, { name: "审核日期", id: "2" }, { name: "确认日期", id: "3" }];
        _this.fromSystemOptions = [{
                id: "1",
                text: "供应链"
            }, {
                id: "4",
                text: "代客下单"
            }];
        _this.signImageOpen = false;
        _this.signImageArr = [];
        return _this;
    }
    PurBackList.prototype.created = function () {
        var _this = this;
        if (this.global_status$$) {
            this.formData.status = [parseInt(this.global_status$$.toString())];
        }
        ;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 120;
            }
        }, 300);
        this.service = PurBackService.getInstance();
        this.commonService = CommonService.getInstance();
        GlobalVue.$on('ro_sign:ok', this.handleSignSuccess);
    };
    PurBackList.prototype.mounted = function () {
        this.areaShopComp = this.$refs.areaShopRef;
        this.getList();
        this.getStatus();
        this.getClient();
    };
    PurBackList.prototype.edit = function (row) {
        this.addTab({
            component: Add,
            title: '修改退货单',
            showExist: true,
            name: 'purchaseback_edit' + row.order_id,
            cprops: {
                order_id: row.order_id
            }
        });
        window._czc.push(["_trackEvent", '退货单', '退货单修改']);
    };
    PurBackList.prototype.viewSignImg = function (row) {
        var _this = this;
        this.service.getSignList({ order_id: row.order_id })
            .then(function (res) {
            var data = res.data;
            if (data.success && data.data.length) {
                if (data.data.length) {
                    var sign_img = data.data;
                    _this.signImageArr = Array.isArray(sign_img) ? sign_img : [];
                    _this.signImageOpen = true;
                }
                else {
                    _this.$message.error("暂无签字图片！");
                }
            }
            else {
                _this.$message.warning('暂无签字图片！');
            }
        }, function (err) { });
    };
    PurBackList.prototype.closeSign = function () {
        this.signImageOpen = false;
    };
    PurBackList.prototype.discard = function () {
        var _this = this;
        var toBeConfirmedOrders = this.selectedData.filter(function (item) { return item.order_sup_status == EPurInStatus.Bconfirm; });
        var order_ids = this.getSelectIds();
        if (!order_ids.length) {
            this.$message.error("请选择单据");
            return;
        }
        this.$confirm("废弃后将不可修改，是否继续？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.rejectCancelOrder({
                order_ids: order_ids
            }).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getList();
                    return;
                }
                _this.$message.success("废弃成功");
                window._czc.push(["_trackEvent", '退货单', '退货单废弃']);
                _this.getList();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurBackList.prototype.importAudit = function () {
        this.$refs.ImportData.showImportModal();
    };
    PurBackList.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    PurBackList.prototype.add = function () {
        this.addTab({
            component: Add,
            title: '新增退货单',
            showExist: true,
            name: 'purchaseback_add',
            cprops: {},
        });
    };
    PurBackList.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        if (this.isMoreSearch) {
            this.isMoreSearch = false;
        }
        var params = this.getFormFilter(pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getList(params).then(function (res) {
            var data = res.data.data;
            _.forEach(data, function (item) {
                item.listGoods = [];
                (item.items || []).push({ isBtn: true });
            });
            _this.tableData = data;
            _this.total = res.data.total;
            _this.summary_order_money = res.data.summary_order_money || 0;
            loadingInstance.close();
            if (params.keyword_type == '1') {
                window._czc.push(["_trackEvent", '客户退货搜索类型', '客户退货搜索类型', '按单号搜索']);
            }
            else if (params.keyword_type == '2') {
                window._czc.push(["_trackEvent", '客户退货搜索类型', '客户退货搜索类型', '按货品搜索']);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurBackList.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.importAudit();
                break;
            case 2:
                this.mulExport();
                break;
            case 3:
                this.mulPrint();
                break;
            case 4:
                this.discard();
                break;
        }
    };
    PurBackList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    PurBackList.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getList();
    };
    PurBackList.prototype.expandChange = function (row, expandedRows) {
        var _this = this;
        if (expandedRows.length == 0) {
            return;
        }
        var params = {
            order_id: row.order_id
        };
        var index = this.tableData.indexOf(row);
        this.service.getListGoods(params).then(function (res) {
            _.forEach(res.data.data, function (item) {
                item.amount = item.order_detail_inamount;
            });
            var listGoods = res.data.data;
            listGoods.push({ isBtn: true });
            GlobalVue.$set(_this.tableData[index], 'listGoods', listGoods);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PurBackList.prototype.getStatus = function () {
        var _this = this;
        this.service.getStatus().then(function (res) {
            if (res.data.success) {
                _this.statusList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PurBackList.prototype.getClient = function () {
        var _this = this;
        this.commonService.getClient().then(function (res) {
            if (res.data.success) {
                _this.clientList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PurBackList.prototype.selectionChange = function (val) {
        this.selectedData = val;
    };
    PurBackList.prototype.searchClick = function () {
        var pagination = this.$refs.pagination;
        var currentPager = pagination ? pagination.getPage() : { page: 1, start: 0, limit: 20 };
        if (pagination) {
            pagination.handleCurrentChange(1);
            return;
        }
        this.getList(currentPager);
    };
    PurBackList.prototype.reset = function () {
        this.formData = getDefaultFormData();
        this.areaShopComp.resetData();
    };
    PurBackList.prototype.detail = function (row) {
        if (row.from_system === 4) {
            toDetail(EBillType.PurBack, row.order_id, this);
            return;
        }
        this.addTab({
            component: OtherDetail,
            title: '退货单详情',
            showExist: true,
            opener: this,
            name: 'purchaseback_detail' + row.order_id,
            cprops: {
                rowId: row.order_id
            }
        });
        window._czc.push(["_trackEvent", '退货单', '退货单详情']);
    };
    PurBackList.prototype.LookImage = function (orderId) {
        var _this = this;
        var params = {
            order_id: orderId
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.orderImgById(params).then(function (res) {
            _this.imageArr = Array.isArray(res.data.data) ? res.data.data : [];
            loadingInstance.close();
            _this.imageOpen = true;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurBackList.prototype.closeimg = function (type) {
        this.imageOpen = type;
    };
    PurBackList.prototype.toDeliver = function (row) {
        toDetail(EBillType.Deliver, row.delivery_order_id);
    };
    PurBackList.prototype.toPurIn = function (row) {
        toDetail(EBillType.PurIn, row.purchase_order_id);
    };
    PurBackList.prototype.mulPrint = function () {
        var orderIds = this.getSelectIds();
        console.info(orderIds);
        if (!orderIds.length) {
            this.$message.error("请选择单据");
            return;
        }
        var url = "./static/js/print/print2.html";
        url = UrlHelper.addParam(url, 'type', "purBack");
        url = UrlHelper.addParam(url, 'order_id', orderIds.join(","));
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
        window._czc.push(["_trackEvent", '客户退货打印', '客户退货打印']);
    };
    PurBackList.prototype.mulExport = function () {
        this.dialogVisible = true;
    };
    PurBackList.prototype.confirmExport = function () {
        var _this = this;
        var orderIds = this.getSelectIds();
        var url = "supplierclientapi/rejectorder/" + (this.exportType == '1' ? 'export_batch' : 'export_batch_detail') + "?order_ids=" + orderIds.join(",");
        url = UrlHelper.addParam(url, 'token', this.user.token);
        var filter = this.getFormFilter();
        for (var key in filter) {
            filter[key] = (filter[key] === undefined || filter[key] === null) ? '' : filter[key];
            url = UrlHelper.addParam(url, key, filter[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        if (this.exportType == '1') {
            window._czc.push(["_trackEvent", '客户退货单导出', '客户退货单导出', '导出单据']);
        }
        if (this.exportType == '2') {
            window._czc.push(["_trackEvent", '客户退货单导出', '客户退货单导出', '导出明细']);
        }
    };
    PurBackList.prototype.getFormFilter = function (pager) {
        if (pager === void 0) { pager = {}; }
        var areaShopValue = this.areaShopComp.getFormData();
        var params = {
            time_type: this.formData.dateType,
            s_time: this.formData.s_time && this.formData.s_time.format("yyyy-MM-dd") || "",
            e_time: this.formData.e_time && this.formData.e_time.format("yyyy-MM-dd") || "",
            order_sup_status: this.formData.status.join(','),
            business_id: this.formData.client,
            keyword_type: this.formData.searchType,
            keyword: this.formData.text,
            is_reconciliation: this.formData.account,
            sort_field: this.order ? this.order[0] : undefined,
            sort_type: this.order ? this.order[1] : undefined,
            area_ids: areaShopValue.area_ids,
            shop_id: areaShopValue.shop_id,
            from_system: this.formData.from_system
        };
        Object.assign(params, pager);
        return params;
    };
    PurBackList.prototype.mulConfirm = function () {
        var _this = this;
        if (!this.selectedData.length) {
            this.$message.error("请选择单据");
            return;
        }
        var orderIds = this.getSelectIds();
        this.$confirm("确认后将不可修改，是否继续？", "", {}).then(function (res) {
            var params = {
                order_id: orderIds.join(",")
            };
            var isForceSign = false;
            var shouldSign = false;
            (_this.selectedData || []).forEach(function (item) {
                if (item.reject_order_confirm_force && item.reject_order_confirm_force == 1) {
                    isForceSign = true;
                }
                if (item.from_system && item.from_system == 1 && item.reject_order_confirm_force && item.reject_order_confirm_force == 1) {
                    shouldSign = true;
                }
            });
            if (shouldSign) {
                var loadingInstance_1 = Loading.service({ fullscreen: true });
                var hisSign_1 = "";
                _this.service.latestSignImg(params).then(function (res) {
                    hisSign_1 = res.data.data.latest_sign_url;
                    var miniprogramQrcode = res.data.data.sign_url.url;
                    _this.$refs.order_sign_dialog.show({
                        type: 'rjo',
                        qrcode: miniprogramQrcode,
                        isForceSign: isForceSign,
                        hisSign: hisSign_1,
                        step: hisSign_1 ? 1 : 2,
                    });
                    loadingInstance_1.close();
                }).catch(function (err) {
                    loadingInstance_1.close();
                    _this.$message.error(err.message || err.msg);
                });
            }
            else {
                _this.afterSign(false, true, false);
            }
        }, function () { });
    };
    PurBackList.prototype.afterSign = function (check, skip_sign, use_latest_sign) {
        var _this = this;
        console.log(check, skip_sign, use_latest_sign);
        if (check) {
            var orderIds = this.getSelectIds();
            this.service.getSignStatus({ order_ids: orderIds.join(',') })
                .then(function (res) {
                var data = res.data;
                if (data.success && data.data.sign_status) {
                    _this.handleSignSuccess();
                }
                else {
                    _this.$message.warning('未获取签字信息，请重新扫码签字');
                }
            }, function (err) { });
        }
        if (skip_sign || use_latest_sign) {
            var orderIds = this.getSelectIds();
            var params = {
                order_ids: orderIds.join(","),
                sign_confirm: skip_sign ? 1 : 0,
                use_latest_sign: use_latest_sign ? 1 : 0,
            };
            var loadingInstance_2 = Loading.service({ fullscreen: true });
            this.service.audit(params).then(function (res) {
                _this.handleSignSuccess(false);
                loadingInstance_2.close();
                if (res.data.code === 55) {
                    var instance = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                        },
                    }, {
                        title: '提示',
                        width: 450,
                        height: 350,
                    }).instance;
                    return;
                }
                if (res.data.code === 8) {
                    handleException(_this, res.data, _this.selectedData[0]);
                    return;
                }
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getList();
                    return;
                }
                var _a = res.data, code = _a.code, data = _a.data;
                if (res.data.code == 69) {
                    var miniprogramQrcode = data && data.msg_data && data.msg_data.url;
                    _this.$refs.order_sign_dialog.show({ type: 'rjo', qrcode: miniprogramQrcode });
                    return;
                }
                if (res.data.code === 9995) {
                    var dialog = _this.$dialog(ConfirmBack, {
                        data: {
                            data: res.data.data,
                            msg: res.data.msg
                        },
                    }, {
                        title: "退货确认",
                        width: 950,
                        height: 600,
                        zIndex: 3000,
                    });
                    dialog.instance.$on("save:ok", function (row) {
                        _this.getList();
                    });
                    return;
                }
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getList();
                    return;
                }
                _this.$message.success(res.data.msg || "操作成功");
                _this.$refs.pagination.clear();
                _this.getList();
                window._czc.push(["_trackEvent", '客户退货确认', '客户退货确认']);
            }).catch(function (err) {
                _this.handleSignSuccess(false);
                loadingInstance_2.close();
            });
        }
    };
    PurBackList.prototype.getSelectIds = function () {
        var orderIds = this.selectedData.map(function (item) { return item.order_id; });
        return orderIds;
    };
    PurBackList.prototype.handleSignSuccess = function (alter) {
        if (alter === void 0) { alter = true; }
        if (alter) {
            this.$message.success('签字成功');
            this.searchClick();
        }
        this.$refs.order_sign_dialog.close();
    };
    PurBackList.prototype.moreSearchComShow = function () {
        this.areaShopComp.getArea();
        this.isMoreSearch = true;
        window._czc.push(["_trackEvent", '客户退货高级查询', '高级查询展开']);
    };
    PurBackList.prototype.moreSearchComHide = function () {
        this.isMoreSearch = false;
        window._czc.push(["_trackEvent", '客户退货高级查询', '高级查询收起']);
    };
    PurBackList = __decorate([
        Component({
            components: {
                'pagination': Pagination,
                BillSubTable: BillSubTable,
                "areaShop": AreaShop,
                'import-data': ImportData,
                'image-view': ImageView,
                'sign-view': SignView,
                'order-sign': OrderSign,
            },
            computed: __assign({}, mapGetters({
                "user": "user",
                "serviceData": 'serviceData',
                "serviceDataList": 'serviceDataList'
            }))
        })
    ], PurBackList);
    return PurBackList;
}(Vue));
export default PurBackList;
